import React from "react";
import { Link } from "gatsby";

const DigitalCase = () => (
  <section className="section--digitalcase">
    <h4
      style={{
        marginTop: 0,
        marginBottom: "1em",
        fontWeight: "600",
      }}
    >
      <p class="text-red">
        Stimați justițiabili,
        <br />
        Începând cu data de 01 ianuarie 2026, aplicaţia InfoDosar nu va mai
        funcţiona.
        <br />
        Pentru accesul la documentele în format electronic din dosarele aflate
        pe rolul Curţii de Apel Timişoara și a instanțelor din raza sa, se pot
        folosi aplicaţiile
        <a
          target="_blank"
          href="https://doc.curteapeltimisoara.ro/autentificare"
        >
          Dosarul Electronic
        </a>{" "}
        şi
        <a target="_blank" href="https://den.just.ro">
          Dosarul Electronic Naţional
        </a>
        . Mai multe informații privind accesul la dosarul în format electronic
        găsiți
        <a target="_blank" href="/dosarulelectronic">
          aici
        </a>
        .
      </p>
      <p>
        Listele cu ședințele de judecată pot fi găsite pe pagina nostră de pe
        <a
          target="_blank"
          href="http://portal.just.ro/59/SitePages/acasa_default.aspx?id_inst=59"
        >
          Portalul instanțelor de judecată
        </a>
      </p>
    </h4>
  </section>
);

export default DigitalCase;
